import React from 'react';
import { Waypoint } from 'react-waypoint';
import classnames from 'classnames';
import FeedThumb from '@wix/da-shared-react/pkg/DeviationViews/Feed';
import { BiLoggerContextProvider } from '@wix/da-shared-react/pkg/biLogger/BiLogger.context';
import { FacetItem, Strip } from '../../../../types/api';
import { isDeviation } from '../../FacetStream/helper';
import s from './BrowseFeed.scss';

export interface Props {
  items: FacetItem[];
  strips?: Strip[];
  className?: string;
  caughtUpIndex?: number;
  markCurrentPageAsSeen: () => void;
}

const BrowseFeed: React.FC<Props> = ({
  items,
  className,
  caughtUpIndex,
  markCurrentPageAsSeen,
}) => {
  return (
    <div className={className}>
      {items.map((item, index) => {
        if (isDeviation(item) && !item.isDeleted) {
          return (
            <>
              {caughtUpIndex === index && (
                <Waypoint onEnter={markCurrentPageAsSeen}>
                  <div className={s['feed-item']} />
                </Waypoint>
              )}
              <BiLoggerContextProvider
                key={item.deviationId}
                value={{ _rankIndex: index }}
              >
                <FeedThumb
                  deviation={item}
                  className={classnames(
                    s['feed-item'],
                    caughtUpIndex && index < caughtUpIndex && s['unread']
                  )}
                  withComments
                  withWatch
                />
              </BiLoggerContextProvider>
            </>
          );
        }
        return null;
      })}
    </div>
  );
};
BrowseFeed.displayName = 'BrowseFeed';

export default BrowseFeed;
